const name = 'order-statuses';

export const GET_ORDER_STATUSES_LIST_REQUEST = `${name}/GET_ORDER_STATUSES_LIST_REQUEST`;
export const GET_ORDER_STATUSES_LIST_SUCCESS = `${name}/GET_ORDER_STATUSES_LIST_SUCCESS`;
export const GET_ORDER_STATUSES_LIST_FAILURE = `${name}/GET_ORDER_STATUSES_LIST_FAILURE`;

export const GET_ORDER_STATUSES_TABLE_CONFIGURATION_REQUEST = `${name}/GET_ORDER_STATUSES_TABLE_CONFIGURATION_REQUEST`;
export const GET_ORDER_STATUSES_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_ORDER_STATUSES_TABLE_CONFIGURATION_SUCCESS`;
export const GET_ORDER_STATUSES_TABLE_CONFIGURATION_FAILURE = `${name}/GET_ORDER_STATUSES_TABLE_CONFIGURATION_FAILURE`;

export const UPDATE_ORDER_STATUSES_TABLE_ROW_REQUEST = `${name}/UPDATE_ORDER_STATUSES_TABLE_ROW_REQUEST`;
export const UPDATE_ORDER_STATUSES_TABLE_ROW_SUCCESS = `${name}/UPDATE_ORDER_STATUSES_TABLE_ROW_SUCCESS`;
export const UPDATE_ORDER_STATUSES_TABLE_ROW_FAILURE = `${name}/UPDATE_ORDER_STATUSES_TABLE_ROW_FAILURE`;

export const CREATE_ORDER_STATUSES_TABLE_ROW_REQUEST = `${name}/CREATE_ORDER_STATUSES_TABLE_ROW_REQUEST`;
export const CREATE_ORDER_STATUSES_TABLE_ROW_SUCCESS = `${name}/CREATE_ORDER_STATUSES_TABLE_ROW_SUCCESS`;
export const CREATE_ORDER_STATUSES_TABLE_ROW_FAILURE = `${name}/CREATE_ORDER_STATUSES_TABLE_ROW_FAILURE`;

export const MOVE_UP_ROW_REQUEST = `${name}/MOVE_UP_ROW_REQUEST`;
export const MOVE_UP_ROW_SUCCESS = `${name}/MOVE_UP_ROW_SUCCESS`;
export const MOVE_UP_ROW_FAILURE = `${name}/MOVE_UP_ROW_FAILURE`;

export const MOVE_DOWN_ROW_REQUEST = `${name}/MOVE_DOWN_ROW_REQUEST`;
export const MOVE_DOWN_ROW_SUCCESS = `${name}/MOVE_DOWN_ROW_SUCCESS`;
export const MOVE_DOWN_ROW_FAILURE = `${name}/MOVE_DOWN_ROW_FAILURE`;

export default name;
